import { Box, Button, ColorMono, Spacing, Typography } from "kvweb-ui";
import OutlineVipCustomerIcon from "../../../../assets/icons/OutlineVipCustomerIcon";
import { IEndSubscriptionProps } from "../../../Modal/Retail/ModalEndSubcriptionNotification";
import { useAdminMerchantContext } from "../../../../contexts/adminMerchant/adminMerchant.context";
import { useEffect, useState } from "react";
import { useRouter } from "../../../../utils/hooks/useRouter";
import { isEmpty } from "lodash";
import {useMediaQuery, useTheme} from "@mui/material";
import {BOOKING_HOTEL_PLATFORM, BOOKING_PLATFORM, FNB_PLATFORM, RETAIL_PLATFORM} from "../../../../utils/constant";
import {useTranslation} from "react-i18next";
import { BRAND_TYPE_KEIVI } from "../../../../services/retail/setting/package_shop_name";

const AlertEndSubscription = ({ retailData, isHideButtonUpgrade = false }: IEndSubscriptionProps) => {
  const [currentRetailInfo, setCurrentRetailInfo] = useState<{
    branchInfo?: IRetailBranchInfo;
    merchantInfo?: IRetailMerchantInfo;
  }>();
  const { retail } = useAdminMerchantContext();
  const router = useRouter();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const platform = router.query.platform
  const {t} = useTranslation()
  useEffect(() => {
    // if (router.query.platform === "retail") {
    setCurrentRetailInfo(retail);
    if (isEmpty(retail)) {
      setCurrentRetailInfo(retailData);
    }
    // }
  }, [retailData, retail]);

  const handleUpgradeNow = () => {
    if (isMobile) {
      //@ts-ignore
      window.upgradeSubscription(platform)
      return
    }
    let url = `https://${currentRetailInfo?.merchantInfo?.ref_code}.${retailData?.merchantInfo?.brand_type === BRAND_TYPE_KEIVI ? process.env.REACT_APP_RETAIL_KEIVI_KMA_DOMAIN_URL : process.env.REACT_APP_RETAIL_KMA_DOMAIN_URL}/man/#/KmaManagement#tab-product`;
    switch (retailData?.merchantInfo?.platform) {
      case FNB_PLATFORM:
        url = `https://${retailData?.merchantInfo?.brand_type === BRAND_TYPE_KEIVI ? process.env.REACT_APP_FNB_KEIVI_KMA_DOMAIN_URL : process.env.REACT_APP_FNB_KMA_DOMAIN_URL}/${currentRetailInfo?.branchInfo?.name}/#/KmaManagement#home`;
        break;
      case BOOKING_PLATFORM:
        url = `https://${retailData?.merchantInfo?.brand_type === BRAND_TYPE_KEIVI ? process.env.REACT_APP_KEIVI_BOOKING_INDUSTRY : process.env.REACT_APP_BOOKING_INDUSTRY}/${currentRetailInfo?.merchantInfo?.ref_code}/#/KmaManagement#home`;
        break;
      case BOOKING_HOTEL_PLATFORM:
        url = `https://${process.env.REACT_APP_BOOKING_INDUSTRY_HOTEL}/${currentRetailInfo?.merchantInfo?.ref_code}/#/KmaManagement#home`
        break
    }
    window.open(url);
  };

  return (
    <Box
      sx={{
        padding: Spacing["space-s"],
        display: "flex",
        justifyContent: "center",
        backgroundImage: "linear-gradient(47deg, #FA6F2F 0%, #F5233C 100%)",
        alignItems: "center",
        position: "sticky",
        top: 0,
        [theme.breakpoints.down("md")]: {
          justifyContent: "space-between",
        },
      }}
    >
      <Typography
        textType={"text14M"}
        sx={{
          [theme.breakpoints.up("md")]: {
            marginRight: Spacing["space-xxl"],
          },
          // [theme.breakpoints.down('md')]: {
          //   minWidth: '230px',
          //   maxWidth: '300px'
          // },
          // [theme.breakpoints.down('sm')]: {
          //   maxWidth: '230px'
          // },
        }}
        color={ColorMono["color-white"]}
      >
        {t("ONBOARDING.YOUR_WEBSITE_IS_END_SUBSCRIPTION")}
      </Typography>
      {!isHideButtonUpgrade && <Button
        btnType="outlined"
        startIcon={<OutlineVipCustomerIcon />}
        onClick={handleUpgradeNow}
        btnSize="medium"
        sx={{
          whiteSpace: "nowrap",
          [theme.breakpoints.down("md")]: {
            width: "155px",
          },
        }}
      >
        <Typography
          textType="text14S"
          sx={{
            [theme.breakpoints.down("sm")]: {
              width: "160px",
            },
            whiteSpace: "nowrap",
          }}
        >
          {t("COMMON.BUTTON.UPGRADE")}
        </Typography>
      </Button>}
    </Box>
  );
};

export default AlertEndSubscription;
